import React, { useEffect } from 'react';
import { Cards } from '@cloudscape-design/components';
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import Header from '@cloudscape-design/components/header';
import { CustomAppLayout } from '../../layout';
import { useRouter } from '../../router';
import { useStore } from '../../store';

import Icon from '@mdi/react';
import { mdiAccountPlusOutline, mdiAccountGroupOutline, mdiLockAlertOutline, mdiAccountMultipleOutline } from '@mdi/js';

const pageSize = 20;

export const UsersPage = () => {
    const {
        actions: { makeHelpPanelHandler },
    } = useStore();
    const { navigate } = useRouter();



    useEffect(() => {
        //handleRefresh();
    }, []);
    const handleOption = (ref: string) => {
        window.location.href = ref
    }
    return (
        <CustomAppLayout
            toolsHide={true}
            breadcrumbs={
                <BreadcrumbGroup
                    items={[
                        { text: 'Inicio', href: '#home' },
                        { text: 'Usuarios', href: '#transcription-job-list' },
                    ]}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <>

                    <Cards
                        selectionType="single"
                        onSelectionChange={({ detail }) => handleOption(detail.selectedItems[0].id)}
                        cardDefinition={{

                            header: item => item.name
                            ,
                            sections: [
                                {
                                    header: "",
                                    content: item => item.description
                                },
                            ]
                        }}
                        cardsPerRow={[
                            { cards: 1 },
                            { minWidth: 500, cards: 3 }
                        ]}
                        entireCardClickable
                        items={[
                            {
                                id: "#users/list",
                                
                                name: (

                                    <span>
                                        <Icon path={mdiAccountGroupOutline} size={1.5} /> Listado
                                    </span>
                                ),
                                description: "Información de todos los usuarios con al menos un acceso asociado",
                            },
                            {
                                id: "#users/add",
                                name: (

                                    <span>
                                        <Icon path={mdiAccountPlusOutline} size={1.5} /> Agregar
                                    </span>
                                ),
                                description: "Asociar un nuevo usuario a uno o más accesos y asignar políticas",
                            },
                            {
                                id: "#users/authorize",
                                name: (

                                    <span>
                                        <Icon path={mdiLockAlertOutline} size={1.5} /> Autorizaciones
                                    </span>
                                ),
                                description: "Usuarios que estan asociados a uno o más accesos, pero que no han sido autorizados",
                            },
                        ]}
                        header={<Header><Icon path={mdiAccountMultipleOutline} size={2} /> Usuarios</Header>}
                    />
                </>
            }
        />
    );
};
